export default __webpack_public_path__ + "static/media/trainingtracker.5d1f0cfb.jpg";